<h2 mat-dialog-title class="bg-primary !text-white">View Attachments</h2>

<mat-dialog-content>
  <table mat-table [dataSource]="attachments" [trackBy]="trackByIndex" class="w-full">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="px-4 py-2 text-left">Name</th>
      <td mat-cell *matCellDef="let att" class="px-4 py-2">{{ att.attachmentName }}</td>
    </ng-container>

    <!-- Url Column -->
    <ng-container matColumnDef="url">
      <th mat-header-cell *matHeaderCellDef class="px-4 py-2 text-left">Url</th>
      <td mat-cell *matCellDef="let att" class="px-4 py-2">
        <a
          href="{{ att.url || att.attachmentDocument }}"
          target="_blank"
          class="text-blue-700 underline"
        >
          {{ att.attachmentName || 'Click to open' }}
        </a>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="px-4 py-2 text-left">Status</th>
      <td mat-cell *matCellDef="let att" class="px-4 py-2">
        <span [ngClass]="{ 'text-gray-700': !isNotSaved(att), 'text-red-500': isNotSaved(att) }">
          {{ getStatus(att) }}
        </span>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="px-4 py-2"></th>
      <td mat-cell *matCellDef="let att; let i = index" class="px-4 py-2 text-center">
        <button mat-icon-button color="warn" (click)="deleteAttachment(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let att; let i = index; columns: displayedColumns"
      [ngClass]="{
        'bg-white': !isNotSaved(att),
        'bg-red-50': isNotSaved(att),
        'hover:bg-gray-100': true,
      }"
    ></tr>
  </table>
  <div *ngIf="attachments.length === 0" class="text-center text-gray-500 py-6">
    There are no attachments.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="close()">CLOSE</button>
</mat-dialog-actions>
